import { gql } from '@apollo/client';
import { EntityReminderFragment } from '../fragments/EntityReminderFragment';
/**
 * @const EntityRemindersQuery
 * @since 1.0.0
 */
export const EntityRemindersQuery = gql `
  query EntityRemindersQuery($input: EntityRemindersInput!) {
    entityReminders(input: $input) {
      ...EntityReminderFragment
    }
  }

  ${EntityReminderFragment}
`;
